

















































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import ShareTheory from "@/views/OWcom/DefShare/ShareTheory.vue";
import ShareFeedBack from "@/views/OWcom/DefShare/ShareFeedBack.vue";
import ShareSchematic from "@/views/OWcom/DefShare/ShareSchematic.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    ShareTheory,
    ShareFeedBack,
    ShareSchematic,
    NextPrevBtn,
    Footer,
  },
})
export default class DefShare extends Vue {
  protected nxtprevDefShare = {
    BoolPrev: false,
    BoolNext: true,
    PrevImage: "",
    NextImage: "/thumbnail7.png",
    PrevLink: "",
    NextLink: "/Definition_Communication/Types_Communication",
  };
}
